// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-9e92e58a]{margin-right:24px;display:flex;align-items:center;cursor:pointer}.logo .hide[data-v-9e92e58a]{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
